/*
 * @Author: ze.wang@diact.com
 * @Date: 2022-12-29 01:40:30
 * @Function: Please Input Function
 */
const validateAnswer = function (errors, vm, showTip) {
  const { answerConfig: { requireInd, maxUploadFileCount, maxUploadFileSize }, value } = this
  const { currentFile, tmpFileList, config, uploadFileTypeList } = vm
  // 上传最大文件个数check
  if ( (tmpFileList && tmpFileList.length > maxUploadFileCount) || (currentFile && value && value.length >= maxUploadFileCount)) {
    errors.push(vm.cvtLang('tipsMaxFilesCountError', config.tipsMaxFilesCountError).replace('${n}', maxUploadFileCount))
    return !errors.length
  }

  // 上传文件类型check
  if (currentFile && uploadFileTypeList) {
    const uploadFileTypeListArr = uploadFileTypeList.split(',')
    let file = currentFile.find(file => {
      const fileType = "." + file.name.split(".").pop();
      return !uploadFileTypeListArr.includes(fileType)
    })

    if (file) {
      errors.push(vm.cvtLang('tipsFileTypeError', config.tipsFileTypeError).replace('${n}', uploadFileTypeList))
      return !errors.length
    }
  }

  //  单个文件的最大文件大小
  if (currentFile) {
    let file = currentFile.find(file => {
      if (file.file) {
        // vant
       return file.file.size > maxUploadFileSize * 1024 * 1024
      } else {
        // element-ui
        return file.size > maxUploadFileSize * 1024 * 1024
      }
    })
    if (file) {
      errors.push(vm.cvtLang('tipsMaxFileSizeError', config.tipsMaxFileSizeError).replace('${n}', maxUploadFileSize))
      return !errors.length
    }
  }

  // 必答题
  if (requireInd === '1') {
    // 未作答
    if (!currentFile && (!value || !value.length)) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }
  }

  return true
}

const validate = function (vm, showTip) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/UploadFileBox/answerValidate.js